module.exports = require("@bechtel/client-assets/dist/images/no-blocks.svg");